import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Chart } from "react-google-charts";
import NoData_Jupiter from "./NoData_Jupiter";
import ChartLoader_Jupiter from "./ChartLoader_Jupiter";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable_Jupiter from "./BuketsTable_Jupiter";
import * as $ from "jquery";

function DischargeDuration_Jupiter({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    // console.log("API Response:", data); // Debug log
    const res_result = data;

    let responce = {
      "0-50": 0,
      "50-100": 0,
      "100-150": 0,
      "150-200": 0,
      "200-250": 0,
      "250-300": 0,
      "300-350": 0,
      "350-400": 0,
      "400-450": 0,
      "450-500": 0,
      ">=500": 0,
    };

    if (res_result && res_result.length > 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;

      temp_result.forEach((d) => {
        // Updated condition to match your API response structure
        if (
          d.discharge_cycle.doc_count > (gloablfilter.DISCHARGE || 0) &&
          (d.deltaOdo.value === 0
            ? d.deltaOdo.value >= (gloablfilter.DELTA || 0)
            : d.deltaOdo.value > (gloablfilter.DELTA || 0))
        ) {
          let value = d.Range.values["50.0"];
          // console.log("Processing value:", value); // Debug log

          if (value >= 0 && value < 50) {
            responce["0-50"] = responce["0-50"] + 1;
          } else if (value >= 50 && value < 100) {
            responce["50-100"] = responce["50-100"] + 1;
          } else if (value >= 100 && value < 150) {
            responce["100-150"] = responce["100-150"] + 1;
          } else if (value >= 150 && value < 200) {
            responce["150-200"] = responce["150-200"] + 1;
          } else if (value >= 200 && value < 250) {
            responce["200-250"] = responce["200-250"] + 1;
          } else if (value >= 250 && value < 300) {
            responce["250-300"] = responce["250-300"] + 1;
          } else if (value >= 300 && value < 350) {
            responce["300-350"] = responce["300-350"] + 1;
          } else if (value >= 350 && value < 400) {
            responce["350-400"] = responce["350-400"] + 1;
          } else if (value >= 400 && value < 450) {
            responce["400-450"] = responce["400-450"] + 1;
          } else if (value >= 450 && value < 500) {
            responce["450-500"] = responce["450-500"] + 1;
          } else if (value >= 500) {
            responce[">=500"] = responce[">=500"] + 1;
          }
        }
      });

      // console.log("Processed response:", responce); // Debug log

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.forEach((x) => {
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });

      // console.log("Chart data:", res_result_final); // Debug log
      setChartData(res_result_final);
    } else {
      // console.log("No data received"); // Debug log
      setChartData([]);
      SetApiResponce([]);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Median Discharge Duration (min)",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8,
      },
      slantedText: true,
      slantedTextAngle: 60,
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    // console.log("Fetching data with filter:", gloablfilter); // Debug log
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {error && (
            <div className="alert alert-danger">
              Error loading data: {error}
            </div>
          )}
          {isLoading ? (
            <ChartLoader_Jupiter />
          ) : chartdata.length === 0 || chartdata.length === 1 ? (
            <NoData_Jupiter />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="247px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      const barLabel =
                        chartWrapper.getDataTable().Wf[row].c[0].v;

                      const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                      let filtered_temp = [];

                      if (count != 0) {
                        if (barLabel === ">=500") {
                          filtered_temp = apiresponce.filter((x) => {
                            if (
                              x.discharge_cycle.doc_count >
                              (gloablfilter.DISCHARGE || 0) &&
                              (x.deltaOdo.value === 0
                                ? x.deltaOdo.value >= (gloablfilter.DELTA || 0)
                                : x.deltaOdo.value > (gloablfilter.DELTA || 0))
                            ) {
                              return x.Range.values["50.0"] >= 500;
                            }
                          });
                        } else {
                          const barvalue = parseInt(barLabel);
                          filtered_temp = apiresponce.filter((x) => {
                            if (
                              x.discharge_cycle.doc_count >
                              (gloablfilter.DISCHARGE || 0) &&
                              (x.deltaOdo.value === 0
                                ? x.deltaOdo.value >= (gloablfilter.DELTA || 0)
                                : x.deltaOdo.value > (gloablfilter.DELTA || 0))
                            ) {
                              return (
                                x.Range.values["50.0"] >= barvalue &&
                                x.Range.values["50.0"] < barvalue + 50
                              );
                            }
                          });
                        }

                        function compareObjects(object1, object2, key) {
                          const obj1 = object1.Range.values["50.0"];
                          const obj2 = object2.Range.values["50.0"];
                          if (obj1 > obj2) {
                            return -1;
                          }
                          if (obj1 < obj2) {
                            return 1;
                          }
                          return 0;
                        }

                        filtered_temp.sort((value1, value2) => {
                          return compareObjects(value1, value2, "key");
                        });

                        SetfilteredData(filtered_temp);
                        window.$("#exampleModal__" + apiend).modal("show");
                      }
                    }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div
                  className="modal-body"
                  style={{ overflowY: "scroll", height: "250px" }}
                >
                  <table className="table table-striped">
                    <thead
                      style={{ backgroundColor: "#32879c", color: "#fff" }}
                    >
                      <tr>
                        <th scope="col">Vehicle ID</th>
                        <th scope="col">Discharge Duration (min)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <BuketsTable_Jupiter data={filteredData} />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DischargeDuration_Jupiter;